import { Box } from '@chakra-ui/react';
import Layout from '../common/Layout';
import { Outlet } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';

const Skills = () => {
  useRole(['support', 'skills']);
  return (
    <Box data-test-id="pact-skills">
      <Layout pageTitle={'Pact'}>
        <Outlet />
      </Layout>
    </Box>
  );
};

export default Skills;
